module.exports = __webpack_public_path__ + "static/media/WebChat.928757b2.png";